import { APICallV3Get } from 'reactApp/api/APICall';

import type { BillingReferralLinkResponse } from './BillingReferralLinkAPICall.types';

export class BillingReferralLinkAPICall extends APICallV3Get<BillingReferralLinkResponse> {
    _method = 'billing/referral/link';
}
